import { render, staticRenderFns } from "./point-table.vue?vue&type=template&id=79476bd6"
import script from "./point-table.vue?vue&type=script&lang=js"
export * from "./point-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79476bd6')) {
      api.createRecord('79476bd6', component.options)
    } else {
      api.reload('79476bd6', component.options)
    }
    module.hot.accept("./point-table.vue?vue&type=template&id=79476bd6", function () {
      api.rerender('79476bd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/point-table.vue"
export default component.exports